import React from "react";
import { Link } from "react-router-dom";

const BarraParaOrdenar = (props) => {
  const {
    onClickOrdenar,
    posicionarEn,
    solosYsolas,
    productos
  } = props;

  const paquetesAereos = productos.filter(
    (p) => p.transporte.descripcion === "AER"
  );
  const paquetesBus = productos.filter(
    (p) => p.transporte.descripcion === "BUS"
  );

  return (
    <div className="sort-bar">
      <div>
        <div className="divOrdenar">Ordenar por: </div>
        {/* <div className="dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            id="dropdownOrdenarPor"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Precio
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownOrdenarPor">
            <Link
              className="dropdown-item"
              to={"#"}
              name="menor"
              onClick={onClickOrdenar}
            >
              Precio Menor
            </Link>
            <Link
              className="dropdown-item"
              to={"#"}
              name="mayor"
              onClick={onClickOrdenar}
            >
              Precio Mayor
            </Link>
          </div>
        </div> */}
        <div className="dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            id="dropdownOrdenarPor"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Paquetes en Bus
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownOrdenarPor">
            {paquetesBus.map((p) => (
              <Link
                key={p.idProducto}
                className="dropdown-item"
                to={"#"}
                onClick={() => posicionarEn(p.idProducto)}
              >{`${p.detalleWeb} ${p.dias} dias / ${p.noches} noches`}</Link>
            ))}
          </div>
        </div>
        <div className="dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            id="dropdownOrdenarPor"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Paquetes en Aereos
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownOrdenarPor">
            {paquetesAereos.map((p) => (
              <Link
                key={p.idProducto}
                className="dropdown-item"
                to={"#"}
                onClick={() => posicionarEn(p.idProducto)}
              >{`${p.detalleWeb} ${p.dias} dias / ${p.noches} noches`}</Link>
            ))}
          </div>
        </div>
      </div>
      {solosYsolas && (
        <div className="divMensaje">
          <p className="mensaje">
            <span>* IMPORTANTE:</span> Los siguientes destinos, son en
            habitacion <strong>A COMPARTIR</strong>, en el caso de no haber otra
            persona en la misma salida, el pasajero podra optar por abonar el
            adicional para base single o reprogramar dicho viaje.
          </p>
        </div>
      )}
    </div>
  );
};

export default BarraParaOrdenar;



// WEBPACK FOOTER //
// ./src/components/Resultados/BarraParaOrdenar.js